/* eslint-disable no-console */
import axios from 'axios'
import { uploadFile } from './transports/file-upload.js'
import { addAttachment } from './attachments/api.js'
axios.defaults.withCredentials = true

export default {
  settings: {
    baseUrl: '/',
    branding: 'SmartEAM',
    checked: false
  },
  async fetchSettings() {
    const response = await fetch(process.env.BASE_URL + 'settings.json')
    const result = await response.json()
    if (result) {
      this.settings.baseUrl = result.baseUrl ? result.baseUrl : this.settings.baseUrl
      this.settings.branding = result.branding ? result.branding : this.settings.branding
    }
  },
  // async runCalculation(params) {
  //   const response = await axios.post(this.settings.baseUrl + 'ws/webcalc/Execute', {
  //     calcId: params.serviceName,
  //     args: JSON.stringify(params.parameters),
  //   }, {
  //     headers: {
  //       'Accept-Language': i18n.locale == 'uk' ? i18n.locale : 'en-US,en;q=0.9,ru;q=0.8,uk;q=0.7'
  //     }
  //   })
  //   return response.data
  // },

  // async tryLogin(params) {
  //   const response = await axios.post(this.settings.baseUrl + 'ws/webcalc/Login', {
  //     login: params.login,
  //     password: params.password,
  //     remember: params.remember
  //   }, {
  //     headers: {
  //       'Accept-Language': i18n.locale == 'uk' ? i18n.locale : 'en-US,en;q=0.9,ru;q=0.8,uk;q=0.7'
  //     }
  //   })
  //   if (response.data && response.data.Success) {
  //     try {
  //       await this.runCalculation({
  //         serviceName: 'PING_AUTH',
  //         parameters: {}
  //       })
  //     } catch (error) {
  //       if (error.response && error.response.data && error.response.data.includes) {
  //         const needTwoFactorAuth = error.response.data.includes('two-factor')
  //         if (needTwoFactorAuth) {
  //           return { ...response.data, needTwoFactorAuth }
  //         }
  //         throw error
  //       }
  //       throw error
  //     }
  //   }
  //   return response.data
  // },

  // async secondFactorLogin(pass) {
  //   return await this.runCalculation({
  //     serviceName: 'CHECKTEMPPASS',
  //     parameters: { TEMPPASSWORD: pass }
  //   })
  // },

  // async logout() {
  //   const response = await axios.post(this.settings.baseUrl + 'ws/webcalc/Logout')
  //   return response.data && response.data.Success
  // },

  async isAuthenticated() {
    const response = await axios.post(this.settings.baseUrl + 'ws/webcalc/IsAuthenticated')
    const result = response.data && response.data.Authenticated
    return result
  },

  addAttachment(params) {
    return addAttachment(params)
  },

  async submitFile(file, params) {
    const filePath = await uploadFile(file.file)

    const attachmentResult = await this.addAttachment({
      table: params.table,
      keyvalue: params.keyvalue,
      filename: file.name,
      filepath: filePath,
      type: ''
    })
    return attachmentResult
  },

  submitFiles(params) {
    return params.files.reduce(
      (series, file) => {
        return series.then(() => {
          return this.submitFile(file, params.parameters)
        })
      },
      Promise.resolve())
  }
}